<template>
  <ToolAdmin
    :user="user"
    tool-id="CustomerServiceSmartSearch"
    tool-name="Smart Search"
    tool-icon="mdi-magnify"
  />
</template>

<script>
import ToolAdmin from './ToolAdmin.vue'

export default {
  name: 'SmartSearchAdmin',
  components: {
    ToolAdmin
  },
  props: ['user']
}
</script> 